
export const zh = {
  site_title: '东京塔景豪华租赁公寓',
  
  // Navigation
  nav_home: '首页',
  nav_rooms: '东京塔景房间',
  nav_rental_guide: '租赁指南',
  nav_life_support: '生活支援',
  nav_contact: '联系我们',
  
  // Hero section
  hero_title: '在东京中心，拥有您专属的特别空间',
  hero_subtitle: '精选高端公寓，让您的东京之旅成为最佳体验',
  hero_cta: '查看房间',
  
  // Features
  features_title: '选择我们的理由',
  feature_1_title: '优质地段',
  feature_1_desc: '位于东京主要区域的精选物业',
  feature_2_title: '全装修',
  feature_2_desc: '完善设施，即刻开始生活',
  feature_3_title: '24小时支持',
  feature_3_desc: '日语、英语、中文邮件支持',
  
  // Rooms
  rooms_title: '精选房间',
  rooms_subtitle: '为您的生活方式量身定制的特别空间',
  view_details: '查看详情',
  monthly_rent: '月租',
  ask_price: '询价',
  reference_price: '参考价格',
  
  // Contact page
  contact_title: '联系我们',
  contact_subtitle: '请通过邮件随时联系我们',
  contact_info_title: '联系信息',
  contact_email_label: '邮箱地址',
  contact_email_response: '我们将在24小时内通过邮件回复',
  contact_method_label: '联系方式',
  contact_method_email_only: '仅通过邮件对应',
  contact_method_note: '不接受电话咨询',
  
  // Contact form
  contact_form_name: '姓名',
  contact_form_name_placeholder: '张三',
  contact_form_email: '邮箱地址',
  contact_form_phone: '电话号码',
  contact_form_phone_placeholder: '+81-90-1234-5678',
  contact_form_room_interest: '感兴趣的房间',
  contact_form_room_select: '请选择',
  contact_form_room_other: '其他/咨询',
  contact_form_move_date: '希望入住日期',
  contact_form_message: '留言',
  contact_form_message_placeholder: '请告诉我们您的问题或要求（500字以内）',
  contact_form_characters: '字',
  contact_form_success: '您的咨询已收到。我们将在24小时内通过邮件回复。',
  contact_form_error: '发送失败。请稍后重试。',
  contact_form_sending: '发送中...',
  contact_form_submit: '发送邮件咨询',
  
  // Room titles
  room_shibuya_title: '涩谷高级工作室',
  room_shinjuku_title: '新宿豪华1LDK',
  room_roppongi_title: '六本木行政套房',
  
  // Rental guide
  rental_guide_title: '日本租赁指南',
  rental_guide_subtitle: '外国人安心租房的完整指南',
  
  // Footer
  footer_contact_title: '联系我们',
  footer_support_hours: '邮件支援对应',
  footer_copyright: '© 2024 Tokyo Rent. All rights reserved.',
  footer_link: 'Website Builder'
};